module.exports = __webpack_public_path__ + "static/media/cq_logout.c6ef8995.svg";